import React from 'react';

export default () => {
  return (
    <div className='buttons'>
      <div className='button buttonAbout'>How it works?</div>
      <div className='button buttonEnter'>Sign up</div>
    </div>
  );
}



/** WEBPACK FOOTER **
 ** ./src/components/Buttons.js
 **/